import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'
import {i18n} from './i18n.js'
console.log('i18n', i18n)
// Authorization
import Login from './views/auth/Login.vue'
import Signup from './views/auth/Signup.vue'
import Reset from './views/auth/Reset.vue'
import ConfirmEmail from './views/auth/ConfirmEmail.vue'
import ResetPasswordConfirm from './views/auth/ResetPasswordConfirm.vue'


// Main Page
// - Users, invite
import Users from './views/Users.vue'
import inviteUser from './views/users/inviteUser.vue'

import Projects from './views/Projects.vue'
import BusinessUnits from './views/BusinessUnits.vue'
import Engagements from './views/Engagements.vue'
import SharedProjects from './views/SharedProjects.vue'
import Clients from './views/Clients.vue'
import Vendors from './views/Vendors.vue'
import ContactsXero from './views/contactsXero/ContactsXero.vue'
import Partners from './views/Partners.vue'
import About from './views/About.vue'
import Calendar from './views/Calendar.vue'
import Invoices from './views/Invoices.vue'
import CreateInvoices from './views/CreateInvoices.vue'
import EditInvoices from './views/EditInvoices.vue'
import Expenses from './views/accountTHINK/expenses.vue'
import Purchases from './views/accountTHINK/purchases.vue'
import ExpenseLiquidation from './views/accountTHINK/expenseLiquidation.vue'
import CashAdvances from './views/accountTHINK/cashAdvances.vue'
import VendorInvoices from './views/accountTHINK/vendorInvoices.vue'
import PaymentEntry from './views/accountTHINK/paymentEntry.vue'
import JournalAndGl from './views/accountTHINK/journalAndGl.vue'
import journalEntries from './views/accountTHINK/journalEntries.vue'
import mailNotification from './views/mailNotification.vue'
import DataRooms from './views/DataRooms.vue'

// Estimate
import ProjectEstimate from './views/estimate/project/Estimate.vue'
import CreateEstimate from './views/estimate/project/CreateEstimate.vue'

// Quotation
import ProjectQuotation from './views/quotation/project/Quotation.vue'
import CreateQuotation from './views/quotation/project/CreateQuotation.vue'

// Sales Order
import ProjectSalesOrder from './views/salesOrder/project/SalesOrder.vue'
import CreateSalesOrder from './views/salesOrder/project/CreateSalesOrder.vue'
import GeneralLedger from './views/GeneralLendger.vue'
import AccountThink from './views/AccountThink.vue'

// Subscriptions
import subscriptions from "@/views/Subscriptions.vue";

// 404
import PageNotFound from './views/404.vue'

// Settings
import Company from './views/settings/Company.vue'
import MyRegions from './views/settings/MyRegions.vue'
// import MyBusinessCenters from './views/settings/MyBusinessCenters.vue'
// import MyBusinessUnits from './views/settings/MyBusinessUnits.vue'
// import MyCompanies from './views/settings/MyCompanies.vue'
// import MyPermissions from './views/settings/MyPermissions.vue'
import Settings from './views/Settings.vue'
import SettingsDashboard from './views/SettingsDashboard.vue'
import Taxation from './views/Taxation.vue'
import TaxationSales from './views/TaxationSales.vue'
import TaxationWithholding from './views/TaxationWithholding.vue'

// dm
import sop from './views/settings/dm/sop.vue'
import policy from './views/settings/dm/policy.vue'
import healthSafety from './views/settings/dm/healthSafety.vue'
import envirenmental from './views/settings/dm/envirenmental.vue'
import riskAssesment from './views/settings/dm/riskAssesment.vue'
import userSigningStatus from './views/settings/dm/status.vue'


import settingsBankAccounts from './views/settings/accountThink/BankAccounts.vue'
import financeBankAccounts from './views/settings/finance/FinanceBankAccounts'
import reconciliationBankAccounts from './views/settings/finance/Reconciliations'
import cashReceipts from './views/settings/finance/CashReceipts'
import cashDisbursements from './views/settings/finance/CashDisbursements'
import settingsCreditCardAccounts from './views/settings/accountThink/CreditCardAccounts.vue'
import settingsTaxAccounts from './views/settings/accountThink/TaxAccounts.vue'
import settingsUnits from './views/settings/accountThink/Units.vue'
import settingsUnitsOfMeasure from './views/settings/accountThink/UnitsOfMeasure.vue'
import settingsPaymentTerms from './views/settings/accountThink/paymentTerms.vue'
import settingsPaymentTypes from './views/settings/accountThink/paymentTypes.vue'
import settingsPaymentMethods from './views/settings/accountThink/paymentMethods.vue'
import settingsItems from './views/settings/accountThink/Items.vue'
import settingsTaxLibraries from './views/settings/accountThink/TaxLibraries.vue'
import settingsOpenBalanceItems from './views/settings/accountThink/OpenBalanceItems.vue'
import settingsOpeningBalanceEquity from './views/settings/accountThink/OpeningBalanceEquity.vue'
import settingsGeneralJournalEntries from './views/settings/accountThink/GeneralJournalEntries.vue'
import settingsBankAccountTypes from './views/settings/accountThink/BankAccountTypes.vue'

// scm
import settingsShippingMethod from './views/settings/scm/shippingMethod.vue'
import settingsItemsSCM from './views/settings/scm/Items.vue'
import settingsItemsTable from './views/settings/items/Items.vue'
import settingsBrands from './views/settings/scm/Brands.vue'
import settingsGoods from './views/settings/scm/Goods.vue'

// crm
import settingsCategoriesGroup from './views/settings/crm/CategoriesGroup.vue'
import settingsItemCategories from './views/settings/crm/ItemCategories.vue'

// TASK TREE TEMPLATES
import settingsBusinessUnitTemplates from './views/settings/taskTreeTemplates/BusinessUnitTemplates.vue'
import settingsEngagementTemplates from './views/settings/taskTreeTemplates/EngagementTemplates.vue'
import settingsProjectTemplates from './views/settings/taskTreeTemplates/ProjectTemplates.vue'

// EMAIL MANAGEMENT
import settingsMailTemplate from './views/settings/emailManagement/mailTemplate.vue'

// ORGANISATION DESIGN
import settingsEngagementTypes from './views/settings/organisationDesign/engagementTypes.vue'
import settingsProjectTypes from './views/settings/organisationDesign/projectTypes.vue'
import settingsCOA from './views/settings/organisationDesign/coa.vue'
import settingsCOAView from './views/settings/organisationDesign/coaView.vue'
import settingsDataRooms from './views/settings/organisationDesign/dataRooms.vue'
import settingsCompliance from './views/settings/organisationDesign/compliance.vue'
import settingsBusinessCenters from './views/settings/organisationDesign/businessCenters.vue'
import settingsRegions from './views/settings/organisationDesign/regions.vue'
import settingsProgressBilling from './views/settings/organisationDesign/progressBilling.vue'
import settingsWarehouse from './views/settings/organisationDesign/warehouse.vue'
import settingsBusinessUnits from './views/settings/organisationDesign/BusinessUnits.vue'

// ORGANISATION PERMISSIONS
import settingsPermissionsCompany from './views/settings/organisationPermissions/permissionsCompany.vue'
import settingsPermissionsBusinessUnits from './views/settings/organisationPermissions/permissionsBusinessUnits.vue'
import settingsPermissionsEngagements from './views/settings/organisationPermissions/permissionsEngagements.vue'
import settingsPermissionsProjects from './views/settings/organisationPermissions/permissionsProjects.vue'

// ORGANISATION INFORMATION
import settingsInformationGeneral from './views/settings/organisationInformation/informationGeneral.vue'
import settingsInformationExpanded from './views/settings/organisationInformation/informationExpanded.vue'
import settingsInformationStatutory from './views/settings/organisationInformation/informationStatutory.vue'
import settingsInformationTaxation from './views/settings/organisationInformation/informationTaxation.vue'
import settingsInformationReport from './views/settings/organisationInformation/informationReport.vue'
import settingsInformationBusiness from './views/settings/organisationInformation/settingsInformationBusiness.vue'
import settingsInformationAccounting from './views/settings/organisationInformation/settingsInformationAccounting.vue'

// PEOPLE AND CULTURE
import WorkPeriods from './views/settings/peopleAndCulture/WorkPeriods.vue'
import WorkItems from './views/settings/peopleAndCulture/WorkItems.vue'
import WorkSchedules from './views/settings/peopleAndCulture/WorkSchedules.vue'
import LeaveManagement from './views/settings/peopleAndCulture/LeaveManagement.vue'
import Payroll from './views/settings/peopleAndCulture/Payroll.vue'

// 1
import totalfowAccounts from './views/settings/accounts/totalfowAccounts.vue'

// worksheet
import worksheet from './views/Worksheet.vue'

// Source Documents
import SourceDocuments from './views/SourceDocuments.vue'

// Warehousing
import Warehousing from './views/Warehousing.vue'

// BUWarehouseManagement
import BUWarehouseManagement from './views/BUWarehouseManagement.vue'

// SuccessCallBack
import SuccessCallback from './views/SuccessCallback.vue'
// CancelCallback
import CancelCallback from './views/CancelCallback.vue'

import Meetings from './views/Meetings.vue'

Vue.use(Router)
/* Layout */
import Layout from '@/layout'
import App from '@/App'

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: App,
      redirect: '/login',
      children: [
        {
          path: '/login',
          name: 'login',
          component: Login
        },
        {
          path: '/signup',
          name: 'signup',
          component: Signup
        },
        {
          path: '/reset',
          name: 'reset',
          component: Reset
        },
        {
          path: '/reset_password_confirm',
          name: 'reset-password-confirm',
          component: ResetPasswordConfirm
        },
        {
          path: '/confirm_email',
          name: 'confirm-email',
          component: ConfirmEmail
        },
        {
          path: 'invite-user',
          name: 'invite-user',
          component: inviteUser
        },
        {
          path: 'mail-notification',
          name: 'mail-notification',
          component: mailNotification
        },
        {
          path: '/meetings',
          name: 'meetings',
          component: Meetings
        }
      ]
    },
    {
      path: '/',
      component: Layout,
      redirect: '/projects',
      children: [{
        path: 'projects',
        name: 'projects',
        component: Projects,
      },
        {
          path: 'settings',
          name: 'settings',
          component: Settings
        },
        {
          path: 'settings-dashboard',
          name: 'settings-dashboard',
          component: SettingsDashboard
        },
        {
          path: 'taxation',
          name: 'taxation',
          component: Taxation
        },
        {
          path: 'taxation-sales',
          name: 'taxation-sales',
          component: TaxationSales
        },
        {
          path: 'taxation-withholding',
          name: 'taxation-withholding',
          component: TaxationWithholding
        },
        {
          path: 'cash-advances',
          name: 'cash-advances',
          component: CashAdvances
        },
        {
          path: 'expenses',
          name: 'expenses',
          component: Expenses
        },
        {
          path: 'journal-and-gl',
          name: 'journal-and-gl',
          component: journalEntries
          // component: JournalAndGl
        },
        {
          path: 'purchases',
          name: 'purchases',
          component: Purchases
        },
        {
          path: 'vendor-invoices',
          name: 'vendor-invoices',
          component: VendorInvoices
        },
        {
          path: 'payment-entry',
          name: 'payment-entry',
          component: PaymentEntry
        },
        {
          path: 'cash-advance-liquidation',
          name: 'cash-advance-liquidation',
          component: ExpenseLiquidation
        },
      {
        path: 'business-units',
        name: 'business-units',
        component: BusinessUnits,
      },
      {
        path: 'engagements',
        name: 'engagements',
        component: Engagements,
      },
      {
        path: 'shared-projects',
        name: 'shared-projects',
        component: SharedProjects,
      },
      {
        path: 'users',
        name: 'users',
        component: Users,
      },
        {
          path: 'clients',
          name: 'clients',
          component: Clients
        },
        {
          path: 'vendors',
          name: 'vendors',
          component: Vendors
        },
        {
          path: 'contacts-xero',
          name: 'contacts-xero',
          component: ContactsXero
        },
        {
          path: 'partners',
          name: 'partners',
          component: Partners
        },
        {
          path: 'about',
          name: 'about',
          component: About
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar
        },
        {
          path: 'invoices',
          name: 'Invoices',
          component: Invoices
        },
        {
          path: 'create-invoices',
          name: 'Create-invoices',
          component: CreateInvoices
        },
        {
          path: 'edit-invoices',
          name: 'Edit-invoices',
          component: EditInvoices
        },
        // Estimate
        {
          path: 'project-estimate',
          name: 'projectEstimate',
          component: ProjectEstimate
        },
        {
          path: 'create-estimate',
          name: 'createEstimate',
          component: CreateEstimate
        },
        // Quotation
        {
          path: 'project-quotation',
          name: 'projectQuotation',
          component: ProjectQuotation
        },
        {
          path: 'create-quotation',
          name: 'createQuotation',
          component: CreateQuotation
        },
        // Sales Order
        {
          path: 'project-salesOrder',
          name: 'projectSalesOrder',
          component: ProjectSalesOrder
        },
        {
          path: 'create-salesOrder',
          name: 'createSalesOrder',
          component: CreateSalesOrder
        },
        {
          path: 'success-callback',
          name: 'successCallback',
          component: SuccessCallback
        },
        {
          path: 'cancel-callback',
          name: 'cancelCallback',
          component: CancelCallback
        },
        // Data Rooms
        {
          path: 'dataRooms',
          name: 'dataRooms',
          component: DataRooms
        },
        {
          path: 'general-ledger',
          name: 'general-ledger',
          component: GeneralLedger
        },
        {
          path: 'account-think',
          name: 'account-think',
          component: AccountThink
        },
        // settings
        {
          path: 'settings-sop',
          name: 'settings-sop',
          component: sop
        },
        {
          path: 'settings-policy',
          name: 'settings-policy',
          component: policy
        },
        {
          path: 'settings-healthSafety',
          name: 'settings-healthSafety',
          component: healthSafety
        },
        {
          path: 'settings-general',
          name: 'settings-general',
          component: envirenmental
        },
        {
          path: 'settings-commercial',
          name: 'settings-commercial',
          component: riskAssesment
        },
        {
          path: 'user-signing-status',
          name: 'user-signing-status',
          component: userSigningStatus
        },
        // account think
        {
          path: 'settings-bank-accounts',
          name: 'settings-bank-accounts',
          component: settingsBankAccounts
        },
        {
          path: 'finance-bank-accounts',
          name: 'finance-bank-accounts',
          component: financeBankAccounts
        },
        {
          path: 'reconciliation',
          name: 'reconciliation',
          component: reconciliationBankAccounts
        },
        {
          path: 'cash-receipts',
          name: 'cash-receipts',
          component: cashReceipts
        },
        {
          path: 'cash-receipts/:id',
          name: 'cash-receipts-update',
          component: cashReceipts
        },
        {
          path: 'cash-disbursements',
          name: 'cash-disbursements',
          component: cashDisbursements
        },
        {
          path: 'cash-disbursements/:id',
          name: 'cash-disbursements-update',
          component: cashDisbursements
        },
        {
          path: 'settings-credit-cards-accounts',
          name: 'settings-credit-cards-accounts',
          component: settingsCreditCardAccounts
        },
        {
          path: 'settings-tax-accounts',
          name: 'settings-tax-accounts',
          component: settingsTaxAccounts
        },
        {
          path: 'settings-units',
          name: 'settings-units',
          component: settingsUnits
        },
        {
          path: 'settings-units-of-measure',
          name: 'settings-units-of-measure',
          component: settingsUnitsOfMeasure
        },
        {
          path: 'settings-goods',
          name: 'settings-goods',
          component: settingsGoods
        },
        {
          path: 'settings-payment-terms',
          name: 'settings-payment-terms',
          component: settingsPaymentTerms
        },
        {
          path: 'settings-payment-types',
          name: 'settings-payment-types',
          component: settingsPaymentTypes
        },
        {
          path: 'settings-payment-methods',
          name: 'settings-payment-methods',
          component: settingsPaymentMethods
        },
        {
          path: 'settings-items',
          name: 'settings-items',
          component: settingsItems
        },
        {
          path: 'settings-tax-libraries',
          name: 'settings-tax-libraries',
          component: settingsTaxLibraries
        },
        {
          path: 'settings-open-balance-items',
          name: 'settings-open-balance-items',
          component: settingsOpenBalanceItems
        },
        {
          path: 'settings-opening-balance-equity',
          name: 'settings-opening-balance-equity',
          component: settingsOpeningBalanceEquity
        },
        {
          path: 'settings-general-journal-entries',
          name: 'settings-general-journal-entries',
          component: settingsGeneralJournalEntries
        },
        {
          path: 'settings-bank-account-types',
          name: 'settings-bank-account-types',
          component: settingsBankAccountTypes
        },
        // scm
        {
          path: 'settings-shipping-method',
          name: 'settings-shipping-method',
          component: settingsShippingMethod
        },
        {
          path: 'settings-items-scm',
          name: 'settings-items-scm',
          component: settingsItemsSCM
        },
        {
          path: 'settings-items-table',
          name: 'settings-items-table',
          component: settingsItemsTable
        },
        {
          path: 'settings-brands',
          name: 'settings-brands',
          component: settingsBrands
        },
        // crm
        {
          path: 'settings-create-categories-group',
          name: 'settings-create-categories-group',
          component: settingsCategoriesGroup
        },
        {
          path: 'settings-item-categories',
          name: 'settings-item-categories',
          component: settingsItemCategories
        },
        // TASK TREE TEMPLATES
        {
          path: 'settings-businessUnit-templates',
          name: 'settings-businessUnit-templates',
          component: settingsBusinessUnitTemplates
        },
        {
          path: 'settings-engagement-templates',
          name: 'settings-engagement-templates',
          component: settingsEngagementTemplates
        },
        {
          path: 'settings-project-templates',
          name: 'settings-project-templates',
          component: settingsProjectTemplates
        },
        // EMAIL MANAGEMENT
        {
          path: 'settings-mail-template',
          name: 'settings-mail-template',
          component: settingsMailTemplate
        },
        // ORGANISATION DESIGN
        {
          path: 'settings-engagement-types',
          name: 'settings-engagement-types',
          component: settingsEngagementTypes
        },
        {
          path: 'settings-project-types',
          name: 'settings-project-types',
          component: settingsProjectTypes
        },
        {
          path: 'settings-coa',
          name: 'settings-coa',
          component: settingsCOA
        },
        {
          path: 'settings-coa-view',
          name: 'settings-coa-view',
          component: settingsCOAView
        },
        {
          path: 'settings-data-rooms',
          name: 'settings-data-rooms',
          component: settingsDataRooms
        },
        {
          path: 'settings-compliance',
          name: 'settings-compliance',
          component: settingsCompliance
        },
        {
          path: 'settings-business-centers',
          name: 'settings-business-centers',
          component: settingsBusinessCenters
        },
        {
          path: 'settings-regions',
          name: 'settings-regions',
          component: settingsRegions
        },
        {
          path: 'settings-progress-billing',
          name: 'settings-progress-billing',
          component: settingsProgressBilling
        },
        {
          path: 'settings-warehouse-types',
          name: 'settings-warehouse-types',
          component: settingsWarehouse
        },
        {
          path: 'settings-business-units',
          name: 'settings-business-units',
          component: settingsBusinessUnits
        },
        // ORGANISATION PERMISSIONS
        {
          path: 'settings-permissions-company',
          name: 'settings-permissions-company',
          component: settingsPermissionsCompany
        },
        {
          path: 'settings-permissions-business-units',
          name: 'settings-permissions-business-units',
          component: settingsPermissionsBusinessUnits
        },
        {
          path: 'settings-permissions-engagements',
          name: 'settings-permissions-engagements',
          component: settingsPermissionsEngagements
        },
        {
          path: 'settings-permissions-projects',
          name: 'settings-permissions-projects',
          component: settingsPermissionsProjects
        },
        // ORGANISATION INFORMATION
        {
          path: 'settings-information-general',
          name: 'settings-information-general',
          component: settingsInformationGeneral
        },
        {
          path: 'settings-information-business',
          name: 'settings-information-business',
          component: settingsInformationBusiness
        },
        {
          path: 'settings-information-accounting',
          name: 'settings-information-accounting',
          component: settingsInformationAccounting
        },
        {
          path: 'settings-information-expanded',
          name: 'settings-information-expanded',
          component: settingsInformationExpanded
        },
        {
          path: 'settings-information-statutory',
          name: 'settings-information-statutory',
          component: settingsInformationStatutory
        },
        {
          path: 'settings-information-taxation',
          name: 'settings-information-taxation',
          component: settingsInformationTaxation
        },
        {
          path: 'settings-information-report',
          name: 'settings-information-report',
          component: settingsInformationReport
        },
        // people and culture
        {
          path: 'settings-work-periods',
          name: 'settings-work-periods',
          component: WorkPeriods
        },
        {
          path: 'settings-work-items',
          name: 'settings-work-items',
          component: WorkItems
        },
        {
          path: 'settings-work-schedules',
          name: 'settings-work-schedules',
          component: WorkSchedules
        },
        {
          path: 'settings-leave-management',
          name: 'settings-leave-management',
          component: LeaveManagement
        },
        {
          path: 'settings-payroll',
          name: 'settings-payroll',
          component: Payroll
        },
        // totalfow Accounts
        {
          path: 'settings-totalfow-accounts',
          name: 'settings-totalfow-accounts',
          component: totalfowAccounts
        },
        // worksheet
        {
          path: 'settings-worksheet',
          name: 'settings-worksheet',
          component: worksheet
        },
        {
          path: 'subscriptions',
          name: 'subscriptions',
          component: subscriptions
        },
        // Source Documents
        {
          path: 'source-documents',
          name: 'source-documents',
          component: SourceDocuments
        },
        {
          path: 'warehousing',
          name: 'warehousing',
          component: Warehousing
        },
        {
          path: 'bu-warehouse-management',
          name: 'bu-warehouse-management',
          component: BUWarehouseManagement
        },
        {
          path: '*',
          component: PageNotFound
        }
      ],
      beforeEnter(to, from, next) {
        // console.log('=== ббббб ===',to.query.companyId, to, store.getters.getActiveSubscription)
        if (sessionStorage.getItem('token')){
          if (to.query.companyId === undefined) {
            return next(`/projects?companyId=${localStorage.getItem('companyId')}`)
          }
          // if (store.getters.getActiveSubscription && to.name !== 'subscriptions') {
          //   return next(`/subscriptions?companyId=${to.query.companyId}`)
          // }
        }

        if (!sessionStorage.getItem('token')){
          return next(`/login`)
        }

        return next()
      },
    }
  ]
})


export default router
